module.exports = __webpack_public_path__ + "static/media/27_tn.9ddb9721.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/27_tn.jpg
// module id = 165
// module chunks = 0